import {amountMask, integerMask, sizeMask, weightMask} from "@/consts/masks";
import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import {getBrandCardboardEnums, getFefcoEnums} from "@/utils/enumsReducer";

export const IPFieldsView = {
    mixins: [useIndividualPacking],
    computed: {
        getFieldsView() {
            return (groupCode) => {
                switch (groupCode) {
                    case 'description':
                    case 'photo':
                    case 'design':
                    case 'stacking':
                    case 'params_seal':
                    case 'fefco':
                    case 'drawing_packaging':
                    case 'brand_cardboard':
                        return 'baseItems'

                    case 'sizes':
                    case 'weight':
                    case 'quantity':
                    case 'count_layout':
                    case 'profile_cardboard':
                    case 'additional_params':
                    case 'accessories':
                    case 'scheme_stacking':
                    case 'sizes_type':
                        return 'groupList'

                    case 'conditions':
                    case 'life':
                    case 'purpose':
                    case 'seal':
                    case 'assembly_conditions':
                    case 'binding_products':
                    case 'wrapping_package':
                    case 'color_front_cardboard':
                    case 'size_pallet':
                        return 'radioList'

                    default:
                        return 'baseItems'
                }
            }
        },
        getFieldsGroupSizeClass() {
            return (groupCode) => {
                switch (groupCode) {
                    case 'description':
                    case 'photo':
                    case 'design':
                    case 'size_pallet':
                    case 'params_seal':
                    case 'fefco':
                    case 'brand_cardboard':
                    case 'drawing_packaging':
                        return ''

                    case 'stacking':
                        return 'form__items--2'

                    case 'count_layout':
                    case 'profile_cardboard':
                    case 'additional_params':
                    case 'accessories':
                    case 'scheme_stacking':
                        return 'form-group__list--auto'

                    case 'sizes':
                    case 'weight':
                    case 'quantity':
                    case 'sizes_type':
                        return 'form-group__list--3'

                    case 'conditions':
                    case 'life':
                    case 'purpose':
                    case 'seal':
                    case 'assembly_conditions':
                    case 'binding_products':
                    case 'wrapping_package':
                    case 'color_front_cardboard':
                        return 'form-group__radios--2'

                    default:
                        return ''
                }
            }
        },
        getFieldsGroupVisibility() {
            return (groupCode) => {
                if (groupCode === 'design' || groupCode === 'params_seal') {
                    if (typeof this.getFormValueByKey('SEAL') === 'string' || typeof this.getFormValueByKey('SEAL') === 'number') {
                        return Number(this.getFormValueByKey('SEAL')) === 1;
                    } else if (Array.isArray(this.getFormValueByKey('SEAL'))) {
                        return this.getFormValueByKey('SEAL').includes(1);
                    }
                }

                if (groupCode === 'stacking') {
                    return this.getFormValueByKey('SCHEME_STACKING') && this.getFormValueByKey('SCHEME_STACKING') !== 4;
                }

                return true;
            }
        },
        getFieldVisibility() {
            return (fieldCode) => {
                if (fieldCode === 'STACKING_FILES') {
                    return this.getFormValueByKey('SCHEME_STACKING') === 3;
                }

                if (fieldCode === 'STACKING_COUNT_ROWS' || fieldCode === 'STACKING_COUNT_IN_ROW') {
                    return this.getFormValueByKey('SCHEME_STACKING') !== 4;
                }

                return true;
            }
        },
        getFieldClass() {
            return (groupCode, fieldCode) => {
                switch (`${groupCode}_${fieldCode}`) {
                    case 'description_NAME':
                    case 'description_DESCRIPTION':
                    case 'photo_PHOTO':
                    case 'design_DESIGN':
                    case 'design_FRONT_INFORMATION':
                    case 'design_DESIGN_ELEMENT':
                    case 'design_LIMITATIONS_DEGIGN':
                    case 'design_WISHES_STYLE':
                    case 'design_COLOR_SCHEME':
                    case 'design_IMAGES_AVOID':
                    case 'design_EXAMPLES_DESIGN':
                    case 'params_seal_DESIGN':
                    case 'params_seal_FRONT_INFORMATION':
                    case 'params_seal_DESIGN_ELEMENT':
                    case 'params_seal_LIMITATIONS_DEGIGN':
                    case 'params_seal_WISHES_STYLE':
                    case 'params_seal_COLOR_SCHEME':
                    case 'params_seal_IMAGES_AVOID':
                    case 'params_seal_EXAMPLES_DESIGN':
                    case 'stacking_STACKING_COUNT_IN_ROW':
                    case 'stacking_STACKING_COUNT_ROWS':
                    case 'fefco_FEFCO':
                    case 'drawing_packaging_DRAWING_PACKAGING':
                    case 'brand_cardboard_BRAND_CARDBOARD':
                        return 'form__item';

                    case 'sizes_WIDTH':
                    case 'sizes_HEIGHT':
                    case 'sizes_LENGTH':
                    case 'sizes_type_WIDTH':
                    case 'sizes_type_HEIGHT':
                    case 'sizes_type_LENGTH':
                    case 'weight_WEIGHT':
                    case 'quantity_QUANTITY':
                    case 'quantity_NUMBER_IN_ROW':
                    case 'quantity_COUNT_ROWS':
                    case 'count_layout_COUNT_LAYERS':
                    case 'profile_cardboard_PROFILE_CARDBOARD':
                    case 'additional_params_ADDITIONAL_PARAMS':
                    case 'accessories_ACCESSORIES':
                    case 'scheme_stacking_SCHEME_STACKING':
                        return 'form-group__item';

                    case 'conditions_STORAGE_CONDITIONS':
                    case 'life_STORAGE_LIFE':
                    case 'purpose_PURPOSE':
                    case 'seal_SEAL':
                    case 'assembly_conditions_ASSEMBLY_CONDITIONS':
                    case 'binding_products_BINDING_PRODUCTS':
                    case 'wrapping_package_WRAPPING_PACKAGE':
                    case 'size_pallet_SIZE_PALLET':
                    case 'color_front_cardboard_COLOR_FRONT_CARDBOARD':
                        return 'form-group__radios-item';

                    case 'stacking_STACKING_FILES':
                        return 'form__item form__item--all';

                    default:
                        return 'form__item';
                }
            }
        },
        getFieldMask() {
            return (fieldCode) => {
                switch (fieldCode) {
                    case 'LENGTH':
                    case 'WIDTH':
                    case 'HEIGHT':
                        return sizeMask

                    case 'WEIGHT':
                        return weightMask

                    case 'QUANTITY':
                    case 'NUMBER_IN_ROW':
                    case 'COUNT_ROWS':
                        return integerMask

                    case 'PRODUCT_QUANTITY':
                        return amountMask

                    default:
                        return null
                }
            }
        },
        shouldBeGroupped() {
            return (fieldCode) => {
                switch (fieldCode) {
                    case 'FEFCO':
                        return true
                    default:
                        return false
                }
            }
        },
        checkDisabled() {
            return (field, item) => {
                if (field.code === 'PROFILE_CARDBOARD') {
                    if (item.count_layout) {
                        return !item.count_layout.includes(this.getFormValueByKey('COUNT_LAYERS'));
                    }
                }

                return false;
            }
        },
        getFieldEnums() {
            return (field) => {
                if (field.type !== 'select') {
                    return field.enum;
                }

                if (field.code === 'FEFCO') {
                    return getFefcoEnums(field.enum);
                }

                if (field.code === 'BRAND_CARDBOARD') {
                    return getBrandCardboardEnums(field.enum, this.getFormValueByKey('COUNT_LAYERS'));
                }

                return field.enum;
            }
        }
    },
}